import { useFormat } from 'helpers/hooks/useFormat';
import React from 'react';
import { Category } from 'shared/types/product/Category';
import { ProjectConfig } from 'types/project-config';
import CertNav from '../cert-nav';

interface CategoryMenuProps {
  categories: Category[];
  activeCategory: Category;
  projectConfig?: ProjectConfig;
}

const CertECardNav: React.FC<CategoryMenuProps> = ({ categories, activeCategory, projectConfig }) => {
  const { formatMessage: formatMessagePadi } = useFormat({ name: 'padi' });

  const allProductText = formatMessagePadi({
    id: 'allCards',
    defaultMessage: 'All eCards',
  });
  // Using slug to define the order
  const categoryOrder = ['certification-card-type-ecard', 'certification-card-special-card-ecard'];
  const subCategoryOrders = {
    'certification-card-type-ecard': [
      'scuba-diving-certification-type-ecard',
      'tecrec-certification-type-ecard',
      'freediver-certification-type-ecard',
      'mermaid-certification-type-ecard',
      'efr-certification-type-ecard',
      'public-safety-diver-certification-type-ecard',
    ],
    'certification-card-special-card-ecard': [
      'special-cards-ecard-limited-edition',
      'special-cards-ecard-aware-donation',
      'special-cards-ecard-destinations',
    ],
  };

  return (
    <CertNav
      categories={categories}
      activeCategory={activeCategory}
      categoryId="certification-card-ecard"
      isActiveECard={true}
      categoryOrder={categoryOrder}
      allProductText={allProductText}
      subCategoryOrders={subCategoryOrders}
      projectConfig={projectConfig}
    />
  );
};

export default CertECardNav;
